<template>
    <div class="breadcrumb">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: $store.state.global.path }">{{$store.state.global.path.replace("/","") | convertMenu}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="secondNav">{{secondNav}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
// import { mapState } from 'vuex'

export default {
  data() {
    return {
      secondNav: '',
      crumbSecond: this.$store.state.global.crumbSecond
    }
  },
  watch: {
    $route: {
      handler: function(val) {
        this.secondaryDisplay(val.path, val.query)
      },
      immediate: true
    }
  },
  methods: {
    // 员工、场景中心、招聘、内推、评优 存在二级
    /*
    [
          {
              path:'/yuangong',
              tabs:[
                  {
                    label:'在招岗位'
                  }
              ]
          }
      ]
    */
    secondaryDisplay(item, query) {
      const haveSecondary = ['/yuangong', '/zhaopin', '/neitui', '/evaluation', '/changjing', '/mobile'] // 存在二级目录的路径
      const allMenus = new Set([...Object.keys(this.$store.state.global.menus)]) // 所有菜单
      const haveSecondaryArr = new Set([...haveSecondary.map(e => { return e.replace('/', '') })]) // 存在二级目录的菜单
      const difference = new Set([...allMenus].filter(x => !haveSecondaryArr.has(x))) // 差异值，即不存在二级菜单
      const doneSecondary = [...difference].map(e => { return `/${e}` }) // 不存在二级目录的路径
      // 存在二级目录的面包屑处理
      if (haveSecondary.indexOf(item) > -1) {
        !query.active && (this.secondNav = '')
        this.crumbSecond.map(e => {
          if (e.path === item && query.active) {
            this.secondNav = e.tabs[query.active].label
          }
        })
      }
      // 不存在二级目录的面包屑处理
      doneSecondary.indexOf(item) > -1 && (this.secondNav = '')
    }
  }
}
</script>

<style  lang="scss">
.breadcrumb{
    padding: 20px 24px;
    background-color: #ffffff;
}
</style>
